import { Injectable } from '@angular/core';
import {NewellLogger} from "./logger.service";

@Injectable({ providedIn: 'root' })
export class NewellLocalStorage {
  private noSupportMessage = `[]: HTML5 localStorage not supported in this Browser!`;
  private hasStorageSupport = true;
  private storage: any;

  constructor(private _log: NewellLogger) {
    if (!NewellLocalStorage.__supportsLocalStorage()) {
      this.hasStorageSupport = false;
      this._log.warn(this.noSupportMessage);
      return;
    }
    /** Assigning window.localStorage to class Storage */
    this.storage = localStorage;
  }


  /**
   * Used to check localStorage support
   */
  private static __supportsLocalStorage() {
    return typeof(NewellLocalStorage) !== 'undefined';
  }

  public set(key, value) {
    this.storage.setItem(key, value);
  }

  public get(key) {
    return this.storage.getItem(key);
  }

  public remove(key) {
    if (this.storage.getItem(key)) {
      this.storage.removeItem(key);
      return true;
    }

    return false;
  }

  public clear() {
    this.storage.clear();
  }

  public setObject(key, value) {
    if (typeof key !== 'string' || typeof value !== 'object') {
      this._log.error('Storage Service:setObject() : Invalid Parameters (key[string], value[object])');
      return false;
    }
    return this.storage.setItem(key, JSON.stringify(value));
  }

  public getObject(key) {
    if (typeof key !== 'string') {
      this._log.error('Storage Service:getObject() : Invalid Parameters (key[string])');
      return false;
    }
    return JSON.parse(this.storage.getItem(key));
  }

  public setEncoded(key, value) {
    const encoded = window.btoa(value);
    this.storage.setItem(key, encoded);
  }

  public getDecoded(key) {
    const value = this.storage.getItem(key);
    return value ? window.atob(value) : null;
  }
}
